import React, { useState } from "react";
import { Helmet } from "react-helmet";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";
import KardexExpoInfo from "./kardex_expo_info";

function KardexExpo () {
    const [masterValue, setMasterValue] = useState('');
    const [hbs, setHbs] = useState('');
    const [notFound, setNotFound] = useState('');
    const [masterData, setMasterData] = useState(null);
    const [showInfo, setShowInfo] = useState(null);

    const mockData = [
        {
          number: '111-12345678',
          type: 'directa',
          merchandiseType: 'Cont activos',
          pzas: 2,
          weight: 27.00,
          cliente: 'FedEx',
          fecha: '2025-04-10',
          origen: 'CMX',
          destino: 'GDL',
          subproducts: [],
        },
        {
          number: '222-87654321',
          type: 'parcial',
          merchandiseType: 'Carga general',
          pzas: 4,
          weight: 48.30,
          cliente: 'UPS',
          fecha: '2025-04-11',
          origen: 'MTY',
          destino: 'TIJ',
          subproducts: [
            { hbs: 'HBS-001', fecha: '2025-04-10', piezas: 1, peso: 5, volume: 17.89 },
            { hbs: 'HBS-002', fecha: '2025-04-11', piezas: 3, peso: 4, volume: 22.43 },
          ]
        }
    ];

    const handleSearch = () => {
        const guide = mockData.find( item => masterValue === item.number);
        if (guide) {
            setNotFound(''); // limpiamos cualquier mensaje anterior
            // alert('proceso para mostrar form');
            setMasterData(guide);
            setShowInfo(true);
        }
        else {
            setNotFound('La master/house no existe, favor de verificar');
            setMasterData(null);
            setShowInfo(false);
        }
    }

    return(
        <>
            <Helmet>
                <title>Horus | Reporteador</title>
            </Helmet>
            <ScrollToTop />

            <div className="container-fluid">
                <div className="row justify-content-start">
                    <div className="col-6 col-md-3">
                        <label for="inputMaster" class="amc-label">Master</label>
                        <input 
                            type="text"
                            className="form-control"
                            id="inputMaster"
                            value={masterValue}
                            onChange={(e) => setMasterValue(e.target.value)}
                        />
                        {/* {error && <small className="text-danger">{error}</small>} */}
                    </div>
                    <div className="col-6 col-md-3">
                        <label for="hbs" class="amc-label">House</label>
                        <input 
                            type="text"
                            className="form-control"
                            id="hbs"
                            value={hbs}
                            onChange={(e) => setHbs(e.target.value)}
                        />
                        {/* {error && <small className="text-danger">{error}</small>} */}
                    </div>
                    <div className="col-12 col-md-3">
                        <div className="btns mt-4">
                            <button className='btnn' onClick={handleSearch} >Buscar</button>
                        </div>
                    </div>
                </div>
                {notFound && (
                    <div className="row mt-3">
                        <div className="col">
                            <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                {notFound}
                            </div>
                        </div>
                    </div>
                )}
                {showInfo && (
                    <KardexExpoInfo master={masterData} />
                )}
            </div>
        </>
    );
}

export default KardexExpo;